import { render } from "./ProjectOverviewPage.vue?vue&type=template&id=678024c4&scoped=true&ts=true"
import script from "./ProjectOverviewPage.vue?vue&type=script&lang=ts"
export * from "./ProjectOverviewPage.vue?vue&type=script&lang=ts"

import "./ProjectOverviewPage.vue?vue&type=style&index=0&id=678024c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678024c4"]])

export default __exports__